import { FunctionComponent } from "react"
import RcSlider from "rc-slider"

export const Slider: FunctionComponent<Parameters<typeof RcSlider>[0]> = (props) => {
    return (
        <div className="rc-slider-wrapper">
            <RcSlider {...props} />
        </div>
    )
}
